module.exports = "https://www.gc-pro.gnp.com.mx/e0a0f9a24527ae13df0bb597404a2c3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-financiero.svg
// module id = 1804
// module chunks = 0